import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router} from '@angular/router';

import {AuthService} from '../services/auth.service';

@Injectable()
export class UnauthGuard implements CanActivate {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.authService.userHasLoggedIn) {
            return true;
        }

        return this.router.navigate(['dashboard']);
    }
}
